import React, {useEffect, useRef} from 'react';
import {Box} from '@mui/material';

const JotFormView = () => {
  const containerRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const script = document.createElement('script');
    script.src = 'https://form.jotform.com/jsform/231075967331155';
    script.type = 'text/javascript';
    container.appendChild(script);

    return () => {
      if (container.contains(script)) {
        container.removeChild(script);
      }
    };
  }, []);

  return (
    <Box>
      <div ref={containerRef}/>
    </Box>
  );
};

export default JotFormView;
